import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import Home from "./pages/Home/Home";
import Guidelines from "./pages/Guidelines/Guidelines";
import Ethics from "./pages/Ethics/Ethics";
import EditorialBoard from "./pages/EditorialBoard/EditorialBoard";
import ConferencePage from "./pages/Conference/ConferencePage";
import ConferenceRegister from "./pages/Conference/ConferenceRegister/ConferenceRegister";
import ConferenceAccommodation from "./pages/Conference/ConferenceAccommodation/ConferenceAccommodation";
import PastNewConference from "./pages/Conference/PastNewConference/PastNewConference";
import ArticleSubmission from "./pages/ArticleSubmission/ArticleSubmission";
import AboutUs from "./pages/AboutUs/AboutUs";
import AboutConference from "./pages/AboutConference/AboutConference";
import AboutJournal from "./pages/AboutJournal/AboutJournal";
import SignIn from "./pages/SignIn/SignIn";
import Register from "./pages/Register/Register";
import SubmitArticle from "./pages/SubmitArticle/SubmitArticle";

import Navbar from "./components/Navbar/Navbar";
import Contact from "./pages/Contact/Contact";
import News from "./pages/News/News";
import GuidelinesForAuthors from "./pages/GuidelinesForAuthors/GuidelinesForAuthors";
import Footer from "./components/Footer/Footer";

// CMS Admin Panel
import AdminPanel from "./pages/Admin/AdminPanel";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import NewAdminPanel from "./pages/Admin/NewAdminPanel";
import AdminMediaLibrary from "./pages/Admin/AdminMediaLibrary";
import AdminLogin from "./pages/Admin/AdminLogin";
import { ContentProvider } from "./contexts/ContentContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export default function App() {
  const location = useLocation();

  // Где скрывать navbar
  const hideNavbarOn = ["/register", "/sign-in", "/admin", "/admin/login", "/admin-panel"];

  const hideNavbar =
    hideNavbarOn.includes(location.pathname) ||
    location.pathname.startsWith('/admin');
  const hideFooter = hideNavbar;

  // Проверяем, находимся ли мы в админке
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <QueryClientProvider client={queryClient}>
      <ContentProvider
        defaultLanguage="en"
        apiUrl={process.env.REACT_APP_API_URL || 'http://localhost:5000/api'}
      >
        {!hideNavbar && <Navbar />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/news" element={<News />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/register" element={<Register />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/about-conference" element={<AboutConference />} />
        <Route path="/about-journal" element={<AboutJournal />} />
        <Route path="/guidelines-for-reviewers" element={<Guidelines />} />
        <Route
          path="/guidelines-for-authors"
          element={<GuidelinesForAuthors />}
        />
        <Route path="/ethics" element={<Ethics />} />
        <Route path="/EditorialBoard" element={<EditorialBoard />} />

        <Route path="/conference" element={<ConferencePage />} />
        <Route path="/conference/past-new" element={<PastNewConference />} />
        <Route path="/conference/register" element={<ConferenceRegister />} />
        <Route
          path="/conference/accommodation"
          element={<ConferenceAccommodation />}
        />

        <Route path="/article-submission" element={<ArticleSubmission />} />
        <Route path="/article-submit" element={<SubmitArticle />} />

        {/* CMS Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/media" element={<AdminMediaLibrary />} />
        <Route path="/admin" element={<NewAdminPanel />} />
      </Routes>

        {!hideFooter && <Footer />}
      </ContentProvider>
    </QueryClientProvider>
  );
}
